define(['jquery',
        'core/urls',
        'components/daterangepicker',
        'components/dropdown',
        'components/datatable',
        'components/request-time-manager',
        'core/browser-storage',
        'core/utilities',
        'core/logo-picker',
        'dual-list-box',
        'jquery.browser',
        '@claviska/jquery-minicolors',
        'components/selectize',
        'jquery.browser',
        'fetch-polyfill'],
    function($, urls, drp, DD, dataTable, requestTM, browser_storage, utilities) {

        let nodes = {
            editBanner: document.querySelector(".edit-banner"),
            editBannerText: document.querySelector(".edit-banner .text"),
            editCancelButton: document.querySelector(".cancel-edit"),
            editCancelConfirmWrap: document.querySelector(".cancel-edit-confirm"),
            editCancelConfirmYes: document.querySelector(".cancel-edit-confirm .yes"),
            editCancelConfirmNo: document.querySelector(".cancel-edit-confirm .no"),
            editSaveButton: document.querySelector(".save-edit"),
            reportType: document.querySelector(".custom-select.report-type"),
            clientOptions: document.querySelectorAll(".client-option"),
            nonClientOptions: document.querySelector(".non-client-options"),
            csatSelector: document.querySelector(".csat-selector"),
            generateReportsButton: document.querySelector("#generateReports"),
            automateReportsButton: document.querySelector("#automateReports"),
            savedReportsWrap: document.querySelector(".manage-automations-wrap"),
            savedReportsHeader: document.querySelector(".manage-automations-wrap h2"),
            savedReportsBody: document.querySelector(".manage-automations-wrap .content-wrapper"),
            reportsPlural: document.querySelectorAll(".reports-plural"),
            generateError: document.querySelector(".error-generate"),
            automateError: document.querySelector(".error-automate"),
            downloadLink: document.querySelector(".download-link"),
            pleaseWait: document.querySelector(".please-wait"),
            generateSuccess: document.querySelector(".success-generate"),
            automateSuccess: document.querySelector(".success-automate"),
            reportName: document.querySelector("#report-name"),
            reportFrequency: document.querySelector("#report-frequency"),
            automationWrap: document.querySelector(".automate-report-wrap"),
            automationInputs: document.querySelectorAll("[data-automation-property]"),
            leaderboardsToggle: document.querySelector("#show-leaderboard"),
            responseToggleWrap: document.querySelector(".response-options"),
            csatReviewsToggle: document.querySelector("#show-csat-reviews"),
            npsMetricsToggle: document.querySelector("#show-nps-metrics"),
            npsResponsesToggle: document.querySelector("#show-nps-responses"),
            npsResponsesToggleWrap: document.querySelector(".show-nps-responses-wrap"),
            automation: {
                frequency: document.querySelector(".custom-select.report-frequency"),
            },
            loadingScreen: document.querySelector(".marketing-loader"),
            pageWrap: document.querySelector(".custom-reports"),
            header: document.querySelectorAll("h2.clickable"),
            generateReportsHeader: document.querySelector(".generate-reports-header"),
            generateReportsBody: document.querySelector(".custom-reports .build-reports"),
            modal: {
                modal: document.querySelector(".modal_js"),
                close: document.querySelector(".modal-close_js"),
                content: document.querySelector(".modal-content_js"),
                title: document.querySelector(".modal-title_js"),
                bg: document.querySelector(".modal-bg_js"),
                blur: [
                    document.querySelector(".custom-reports"),
                    document.querySelector(".sidebar-nav"),
                    document.querySelector(".navigation-top")
                ],
            },
        }

        let logo_picker;
        let automationIDs = [];
        let fetchingData = false;
        let csrfToken = document.querySelector("[name='csrfmiddlewaretoken']").value;

        let enterEditFlow = (dataString) => {
            
            let data = JSON.parse(dataString);
            
            // open report details section
            nodes.generateReportsBody.classList.remove("hide");
            nodes.generateReportsHeader.classList.add("active");

            let reportTypeOption = nodes.reportType.querySelector(`.mock-option[data-value='${data.type}']`);
            reportTypeOption.click(); // click saved report type, which will update all page options to match

            const checkForFetchingData = setInterval(function() {
                if(fetchingData) return; // this variable is set to false after "selections" data response received

                // done fetching data. Clear this interval and proceed with selections
                 clearInterval(checkForFetchingData)

                 // update list selections
                let selectionParent = document.querySelector(".dual-list-box-container");
                let selections = data.settings.selections;
                let addOptionButton = selectionParent.querySelector("button.str");

                addOptionButton.disabled = false;

                selections.forEach(selection => {
                    let option = selectionParent.querySelector(`.unselected option[value="${selection}"]`);
                    option.selected = true;
                })

                addOptionButton.click();
            }, 100);

            
            if(data.type === "client") {
                let csatToggle = document.querySelector("#show-csat");
                let npsToggle = document.querySelector("#show-nps");
                let projectToggle = document.querySelector("#show-projects");

                // update report score types for client reports
                if(csatToggle) csatToggle.checked = data.settings.score_type.includes("csat");
                if(npsToggle) npsToggle.checked = data.settings.score_type.includes("nps");
                if(projectToggle) projectToggle.checked = data.settings.score_type.includes("projects");
                
            } else {
                // update leaderboard preference for all other reports
                document.querySelector("#show-leaderboard").checked = data.settings.show_leaderboards;
            }

            // update comment/review settings
            document.querySelector("#show-csat-reviews").checked = data.settings.show_responses_with_comments;
            document.querySelector("#show-all-reviews").checked = data.settings.show_all_reviews;
            
            // update color picker
            $('.minicolors-input').minicolors('value', data.settings.color);

            
            // update report name
            nodes.reportName.value = data.name;
            nodes.automation.frequency.querySelector(`.mock-option[data-value='${data.frequency}']`).click();


            // update emails
            let emailField = $("#recipients")[0].selectize;
            emailField.clear();

            data.recipients.forEach((recipient) => {
                emailField.createItem(recipient)
            })

            //deselect current logo or open logo selector
            let logoDeselector = document.querySelector(".uploader-delete-logo_js");
            if(logoDeselector) {
                logoDeselector.click();
            } else {
                document.querySelector(".uploader-open_js").click();
            }

            // if data contains logo, select and display it
            if(data.logo) {
                let logoContainer = document.querySelector(`.sb-modal-upload__select .logo-item_js[data-id="${data.logo}"]`);
                
                if(logoContainer) {
                    logoContainer.click();
                } else {
                    // logo has been deleted, close modal
                    document.querySelector(".modal-bg_js").click();
                }
            } else {
                // no logo in data, so close modal
                document.querySelector(".modal-bg_js").click();
            }
            

            // update layout for edit mode
            nodes.automateReportsButton.classList.add("hide");
            nodes.editBannerText.innerHTML = `<strong>Editing Automation</strong>: ${utilities.sanitizeData(data.name)}`;
            nodes.editBanner.classList.remove("hide");
            nodes.savedReportsHeader.classList.remove("active");
            nodes.savedReportsBody.classList.add("hide");
            nodes.generateReportsHeader.innerHTML = `Edit Automation: ${utilities.sanitizeData(data.name)}`;    
            
            // add ID to save button
            nodes.editSaveButton.dataset.id = data.id;            
            
            // scroll into view
            window.scrollTo({
                top: 200,
                left: 0,
                behavior: "smooth",
            });
        } // done edit flow

        let cancelEdit = () => {
            nodes.editCancelButton.classList.add("hide");
            nodes.editCancelConfirmWrap.classList.remove("hide");
            
            nodes.editCancelConfirmYes.addEventListener("click", () => {
                location.reload();
            })

            nodes.editCancelConfirmNo.addEventListener("click", () => {
                nodes.editCancelButton.classList.remove("hide");
                nodes.editCancelConfirmWrap.classList.add("hide");
            })
        }

        let editReportSave = () => {
            let reportID = nodes.editSaveButton.dataset.id;
            let submit = submitReports(true, reportID);

            if(submit !== "invalid") {
                nodes.editBanner.classList.add("hide");
                nodes.savedReportsHeader.classList.add("active");
                nodes.savedReportsBody.classList.remove("hide");
                nodes.generateReportsHeader.innerText = `Generate Reports`;  
                setTimeout(() => {
                    nodes.automateReportsButton.classList.remove("hide");
                }, 500)
            }
        }

        let createTableEvents = () => {
            let table = document.querySelector("#automationList");

            // event delegation to capture clicks on not yet rendered elements
            table.addEventListener("click", (event) => {
                if(event.target.classList.contains("edit-automation")){
                    event.preventDefault();
                    let data = event.target.getAttribute("data-full");
                    enterEditFlow(data);
                }

                if(event.target.classList.contains("remove-automation-wrap") || event.target.classList.contains("remove-automation")){
                    let id = event.target.getAttribute("data-id");
                    table.querySelector(`.remove-automation-wrap[data-id="${id}"]`).classList.add("hide");
                    table.querySelector(`.remove-automation-confirm[data-id="${id}"]`).classList.remove("hide");
                }

                if(event.target.classList.contains("remove-no")){
                    let id = event.target.getAttribute("data-id");
                    table.querySelector(`.remove-automation-wrap[data-id="${id}"]`).classList.remove("hide");
                    table.querySelector(`.remove-automation-confirm[data-id="${id}"]`).classList.add("hide");
                }
        
                if(event.target.classList.contains("remove-yes")){
                    let id = event.target.getAttribute("data-id");
                    let row = table.querySelector(`[data-automation-id='${id}']`);
                    fetch(`/reporting/remove/${id}/`, {
                        method: "POST",
                        headers: {
                            'X-CSRFToken': csrfToken,
                        },
                    })
                    .then(() => {
                        row.classList.add("deleted");

                        setTimeout(() => {
                            row.remove();

                            let remainingRows = table.querySelector("tbody td");
                            if(!remainingRows) {
                                document.querySelector(".manage-automations-wrap").classList.add("hide");
                                document.querySelector(".custom-reports h2.clickable").classList.remove("clickable");
                                document.querySelector(".custom-reports .build-reports").classList.remove("hide");
                            }
                        }, 400)
                    })
                };
            })
        }

        let getSelectionsData = (value, title) => {
            fetchingData = true;

            //activate loading screen
            nodes.loadingScreen.classList.remove("disabled");

            let selectionTypes = document.querySelectorAll(".selection-type");

            fetch(urls['reporting:data'](value))
            .then(
                function(response) {
                    response.json().then(function(data) {
                        let container = document.querySelector(".dual-list-box-container");

                        container.innerHTML = '';

                        let options = data[value] ? data[value].map(record => `
                            <option value="${record}" data-title="${record}">${record}</option>`) : [];

                        let selectEl = `<select id="report-selections" multiple="multiple" class="form-control selectize-manually">${options}</select>`
                        container.innerHTML = selectEl;                        
                        let reportSelections = $('#report-selections');

                        let selectionCallback = () => {
                            let selectedOptions = [];

                            if($.browser.mobile) {
                                selectedOptions = $('#report-selections')[0].selectedOptions;
                            } else {
                                selectedOptions = document.querySelectorAll(".dual-list-box-container select.selected option");
                            }
                            
                            nodes.generateSuccess.classList.add("hide");
                            nodes.automateSuccess.classList.add("hide");
                            
                            // grammar
                            nodes.reportsPlural.forEach(node => {
                                selectedOptions.length > 1 ? node.classList.remove("hide") : node.classList.add("hide");
                            })
                        }

                        if ($.browser.mobile) {
                            // Detected mobile device - using default multi-select box
                            reportSelections.addClass('mobile');
                            $('#report-selections-label').css('display', 'block');
                            reportSelections.on('change', selectionCallback);
                        } else {
                            reportSelections.DualListBox({
                                json: false,
                                title: title+'s',
                                selectedText: 'Selected',
                                selectClass: 'form-control selectize-manually',
                                availableText: 'All',
                                filterText: 'Search...',
                                beforeCount: '(',
                                afterCount: ')',
                                showingText: '',
                                changeCallback: () => selectionCallback(),
                            });
                        }
                        
                        selectionTypes.forEach(node => {
                            node.innerText = `${title}s`;
                        });

                        //disable loading screen
                        nodes.loadingScreen.classList.add("disabled");

                        if(nodes.pageWrap.classList.contains("hide")) {
                            nodes.pageWrap.classList.remove("hide");
                        }

                        fetchingData = false;
                    });
                }
            )
            .catch(function(err) {
                console.log('Fetch Error :-S', err);
            });
        }

        function onDateChange() {
            drp.saveToBrowserStorage('csat-client-reports');
        }

        let DDReportType = DD(nodes.reportType, (value, id, target) => {
            if(nodes.npsResponsesToggle) nodes.npsResponsesToggle.checked = false;
            if(nodes.npsMetricsToggle) nodes.npsMetricsToggle.checked = false;
            nodes.leaderboardsToggle.checked = false;
            // nodes.csatReviewsToggle.checked = true;

            if(value === "client") {
                nodes.clientOptions.forEach(option => {
                    option.classList.remove("hide");
                    option.querySelector("input").checked = true;
                })
                nodes.nonClientOptions.classList.add("hide");
                if(nodes.csatSelector) {
                    nodes.csatSelector.classList.remove("disabled");
                }
                
            } else {
                nodes.clientOptions.forEach(option => {
                    option.classList.add("hide");
                    option.querySelector("input").checked = false;
                })
                nodes.nonClientOptions.classList.remove("hide");
                // ensure CSAT is selected, and disabled
                if(nodes.csatSelector) {
                    nodes.csatSelector.querySelector("input").checked = true;
                    nodes.csatSelector.classList.add("disabled");
                }
                if(nodes.npsResponsesToggleWrap) nodes.npsResponsesToggleWrap.classList.add("disabled");
            }

            getSelectionsData(value, target.dataset.title)
        });

        let validateSettings = (selectedCount, reportType, scoreTypes, automateSelected) => {

            let hasError = false;

            document.querySelectorAll(".error").forEach(node => {
                node.classList.add("hide");
            })

            let selectError = `Please select at least one option from the ${reportType} list`;
            let scoreTypeError = "Please select at least one Survey Type (CSAT, NPS, Project Surveys) to include in your report";

            if(automateSelected) {
                if(!selectedCount) {
                    nodes.automateError.innerText = selectError;
                    nodes.automateError.classList.remove("hide");
                    hasError = true;
                }

                if(!scoreTypes.length) {
                    nodes.automateError.innerText = scoreTypeError;
                    nodes.automateError.classList.remove("hide");
                    hasError = true;
                }

                nodes.automationInputs.forEach(node => {
                    let inputName = node.getAttribute("data-automation-property");
                    let errorNode = document.querySelector(`[data-error-property='${inputName}'`)

                    if(!node.value) {
                        errorNode.innerText = errorNode.getAttribute("data-empty");
                        errorNode.classList.remove("hide");
                        hasError = true;
                    }

                    if(inputName === "report_name" && node.value) {
                        let regEx = /(^[\w\-\s]+$)/;

                        if(!regEx.test(node.value)) {
                            errorNode.innerText = "Please use alphanumeric characters only (A-Z, 0-9)";
                            errorNode.classList.remove("hide");
                            hasError = true;
                        }

                        if(node.value.length > 60) {
                            errorNode.innerText = "Please enter 60 characters or less";
                            errorNode.classList.remove("hide");
                            hasError = true;
                        }
                    }

                    if(inputName === "recipients" && node.value) {
                        Array.prototype.forEach.call(node.options, (option) => {
                            let email = option.value;
                            let regEx = /(^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$)/;

                            if(!regEx.test(email.toLowerCase())) {
                                errorNode.innerText = "You have entered an invalid email";
                                errorNode.classList.remove("hide");
                                hasError = true;
                            }
                        })
                    }
                })

                let firstError = document.querySelector(".error:not(.hide)");
                if(firstError) firstError.scrollIntoView();
                
                return hasError;
            } 
            
            if(!selectedCount) {
                nodes.generateError.innerText = selectError;
                nodes.generateError.classList.remove("hide");
                hasError = true;
            }

            if(!scoreTypes.length) {
                nodes.generateError.innerText = scoreTypeError;
                nodes.generateError.classList.remove("hide");
                hasError = true;
            }

            return hasError;
        }

        let DDReportFrequency = DD(nodes.automation.frequency, () => {});

        let dataTimeManager = new requestTM();

        let submitReports = (automate, editID) => {
            let inputs = document.querySelectorAll("[data-property]");

            let data = {
                logo_id: document.querySelector("#id_logo").value || 0,
                selections: [],
                automate: false,
                score_type: [],
            }

            // gather all selected options and populate list
            if($.browser.mobile) {
                $('#report-selections')[0].selectedOptions.forEach(option => {
                    data.selections.push(option.value);
                })
            } else {
                document.querySelectorAll("select.selected option").forEach(option => {
                    data.selections.push(option.value);
                })
            }

            // get data from all other inputs
            inputs.forEach((input) => {
                if(!input.disabled && !input.parentElement.parentElement.classList.contains("hide")) {
                    let keyName = input.getAttribute("data-property");
                    if(keyName === "score_type") {
                        if(input.checked) data.score_type.push(input.getAttribute("data-value"))
                    } else {
                        data[keyName] = input.type === "checkbox" ? input.checked : input.value;
                    }
                }                        
            });

            if(automate) {
                data.automate = true;
                // get data from automation inputs if selected
                nodes.automationInputs.forEach((input) => {
                    data[input.getAttribute("data-automation-property")] = utilities.sanitizeData($(input).val()); // jquery does a good job of gathering multiselect values this way            
                });
            } else {
                // add date range for report generation
                data.start_date = drp.getStartDate().format('YYYY-MM-DD');
                data.end_date = drp.getEndDate().format('YYYY-MM-DD');
            }

            if(validateSettings(data.selections.length, data["report_type"], data["score_type"], automate)){
                return "invalid";
            }

            if(automate) {
                nodes.automateReportsButton.classList.add("loading");

                let url = editID ? `/reporting/submit/${editID}/` : '/reporting/submit/'

                fetch(url, {
                    method: "POST",
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'X-CSRFToken': csrfToken,
                    },
                    body: JSON.stringify(data)
                })
                .then(() => {
                    dataTimeManager.abort({success: true});

                    let automationsWrap = document.querySelector(".manage-automations-wrap");

                    automationsWrap.classList.remove("hide");
                    automationsWrap.scrollIntoView();

                    document.querySelector(".custom-reports h2").classList.add("clickable");
                    nodes.generateReportsBody.classList.add("hide");
                    nodes.generateReportsHeader.classList.remove("active");

                    dataTable.reloadData("#automationList", (data) => {

                        let newAutomationIDs = [];

                        data.data.forEach(row => {
                            newAutomationIDs.push(row.id * 1);
                        })

                        let highlightRow = (id) => {
                            let highlightRow = document.querySelector(`[data-automation-id="${id}"]`);
                            if(!highlightRow) return;
                            highlightRow.classList.add("highlight");
                            highlightRow.scrollIntoView();

                            setTimeout(() => {
                                highlightRow.classList.remove("highlight");                                
                            }, 4000);
                        }

                        if(editID) {
                            highlightRow(editID)
                        } else {
                            if (automationIDs.length && newAutomationIDs.length !== automationIDs.length) {
                                let newID = newAutomationIDs.filter(x => !automationIDs.includes(x))
                                highlightRow(newID)
                            }
                        }                        

                        automationIDs = newAutomationIDs;
                    });

                    // reset form to default
                    nodes.reportName.value = '';
                    nodes.automationWrap.querySelector(".mock-options div").click();
                    $("#recipients")[0].selectize.clear();

                    nodes.automateReportsButton.classList.remove("loading");
                    nodes.automateSuccess.classList.remove("hide");

                    setTimeout(() => {
                        nodes.automateSuccess.classList.add("hide");
                    }, 4000)
                })
            } else {
                nodes.generateReportsButton.classList.add("loading");
                nodes.generateSuccess.classList.add("hide");
                nodes.pleaseWait.classList.remove("hide");
            

                let dataRequest = () => { // perform recurring requests for generate report until it returns a success
                    var xhr = new XMLHttpRequest();

                    xhr.open("POST", '/reporting/submit/', true);
                    dataTimeManager.addXHR(xhr);
                    xhr.setRequestHeader("Content-Type", "application/json");
                    xhr.setRequestHeader("X-CSRFToken", csrfToken)

                    xhr.onreadystatechange = function () {
                        let data = {};

                        try {
                            data = JSON.parse(xhr.responseText);
                        } catch (e) {
                            data = {success: false};
                        }

                        switch (true) {
                            case xhr.status === 500:
                                break;

                            case xhr.status === 0:
                                data = {success: false};
                                return;

                            case xhr.status !== 200:
                                data = {success: false};
                                break;
                        }

                        new Promise(function(resolve) { 
                            let timeout = data.success ? 300 : 0
                            setTimeout(resolve, timeout);
                        }).then(function() { 
                            if (data.success) {
                                dataTimeManager.abort({success: true});

                                nodes.generateReportsButton.classList.remove("loading");
                    
                                if(automate) {
                                    
                                } else {
                                    nodes.downloadLink.setAttribute("href", `/reporting/download/${data.task}`);
                                    nodes.generateSuccess.classList.remove("hide");
                                    nodes.pleaseWait.classList.add("hide");
                                }
                            }
                        });
                    };

                    xhr.send(JSON.stringify(data));
                };
                
                dataTimeManager.interval(dataRequest);
            }
        }

        $.fn.dataTable.ext.type.order['frequency-pre'] = function ( data ) {
            let order;
            switch(data) {
                case "weekly":
                    order = 1;
                    break;
                case "monthly":
                    order = 2;
                    break;
                case "quarterly":
                    order = 3;
                    break;
                case "biannually":
                    order = 4;
                    break;
                case "yearly":
                    order = 5;
                    break;
                    }
         
            return order;
        };

        let createDataTable = () => {
            let restricted = document.querySelector("#automationList").dataset.restricted;

            dataTable.create('#automationList', {
                columns: [
                    {
                        title: 'Name',
                        className: 'column-name',
                        data: 'name',
                        width: '15%',
                        render: {
                            display: function(data) {
                                return utilities.sanitizeData(data);
                            }
                        }
                    },
                    {
                        title: 'Selections',
                        className: 'column-selections',
                        data: 'settings.selections',
                        width: "30%",
                        render: {
                            display: function(data) {
                                output = data.map(selection => {
                                    return `<span class="selection">${selection}</span>`
                                }).join("");

                                return `<div class="selections">${output}</div>`
                            }
                        }
                    },
                    {
                        title: 'Recipients',
                        className: 'column-recipients',
                        data: 'recipients',
                        width: "30%",
                        render: {
                            display: function(data) {
                                output = data.map(recipient => {
                                    return `<span class="recipient">${utilities.sanitizeData(recipient)}</span>`
                                }).join("");

                                return `<div class="recipients">${output}</div>`
                            }
                        }
                    },
                    {
                        title: 'Frequency',
                        width: "120px",
                        className: 'column-frequency',
                        data: 'frequency',
                    },
                    {
                        title: '',
                        className: 'column-delete',
                        data: 'id',
                        width: '15%',
                        render: {
                            display: function(data, type, full) {
                                if(restricted) return '';
                                let disabledClass = "";
                                let tooltip = "";
                                
                                if(full.is_old_report) {
                                    disabledClass = "disabled";
                                    tooltip = `
                                        <div class="sb-tooltip">
                                        This report is an old format and cannot be edited. 
                                        If you want to change it please create new report and delete this one.
                                        </div>
                                    `
                                }

                                return `
                                    <div class="flex-wrapper">
                                        <div class="tooltip-wrap">
                                            <div data-id="${data}" data-full='${utilities.sanitizeData(JSON.stringify(full))}' role="button" class="${disabledClass} btn btn-primary edit-automation icon glyphicons glyphicons-pencil">
                                            </div>
                                            ${tooltip}
                                        </div>
                                        <div data-id="${data}" class="btn btn-danger remove-automation-wrap">
                                            <div data-id="${data}" class="remove-automation icon glyphicons glyphicons-remove-sign"></div>
                                        </div>
                                        <div data-id="${data}" class="remove-automation-confirm hide">
                                            Delete?
                                            <div class="options">
                                                <span data-id="${data}" class="remove-yes">Yes</span>
                                                <span data-id="${data}" class="remove-no">No</span>
                                            </div>
                                        </div>
                                    </div>`
                            }
                        }
                    },
                ],
                columnDefs: [
                    { orderable: false, targets: [1,2,4] }
                ],
                language: {
                    searchPlaceholder: "Search",
                    search: '',
                    paginate: {
                        previous: "Prev",
                        next: "Next",
                    },
                    lengthMenu: `Results per page: 
                            <div class='custom-select thin limit-selector'>
                            _MENU_
                            <img src="/static/icons/select-arrow.svg" alt="">
                            </div>`,
                },
                stateSave: false,
                paging: true,
                pageLength: 10,
                ajax: {
                    url: '/reporting/list/',
                    dataSrc: 'data',
                    async: false,
                    error: function (jqXHR, textStatus, errorThrown) {
                        if (jqXHR.status == 302) {
                            // server requested a page reload
                            window.location.reload();
                        } else if(jqXHR.status == 403) {
                             window.location.href = urls['account:auth-login']() + '?next=' + window.location.pathname;
                        } else {
                            $('.dataTables_empty').text('Error loading data. Auto-retrying in less than 5 minutes...');
                        }
                    }
                },
                buttons: [],
                info: false,
                createdRow: function (row, data) {
                    $(row).attr('data-automation-id', data.id);
                },
                initComplete: function() {
                    let api = this.api();
                    let response =  api.ajax.json();

                    if(response) {
                        if(response.data.length) {
                            document.querySelector(".manage-automations-wrap").classList.remove("hide");
                        } else {
                            document.querySelector(".custom-reports h2.clickable").classList.remove("clickable");
                            document.querySelector(".custom-reports .build-reports").classList.remove("hide");
                        }
                    }

                    table = $('#automationList').DataTable();

                    response.data.forEach(row => {
                        automationIDs.push(row.id * 1);
                    })

                    let limitSelector = document.querySelector("#automationList_wrapper .limit-selector")
                    DD(limitSelector, (val) => {
                        table.page.len(val).draw();
                    })

                    //add icon to search filter bar
                    let imageHtml = document.createElement("IMG");
                    imageHtml.src = "/static/icons/ic-search.svg";
                    let searchBar = document.querySelector("#automationList_filter");

                    searchBar.append(imageHtml);

                    createTableEvents();
                    
                }
            });
        }


        return {
            init: function() {
                //activate loading screen
                nodes.loadingScreen.classList.remove("disabled");

                // initialize the date range picker
                drp.create({}, onDateChange);
                drp.loadFromBrowserStorage('csat-client-reports');

                DDReportType.reset();
                DDReportFrequency.reset();
                
                // initialize colour picker
                $('.minicolors-input').minicolors($.minicolors.defaults);

                if(browser_storage.getItem("report-color")){
                    $('.minicolors-input').minicolors('value', browser_storage.getItem("report-color"));
                }

                $('.minicolors-input').on("change", (el) => {
                    browser_storage.setItem("report-color", el.target.value);
                })

                $(".minicolors .reset-input").on("click", () => {
                    $('.minicolors-input').minicolors("value", "#00054d");
                    browser_storage.setItem("report-color", "#00054d");
                })

                // only allow one responses toggle to be checked at a given time
                nodes.responseToggleWrap.querySelectorAll("input").forEach((input) => {
                    input.addEventListener("click", (event) => {
                        if(event.target.checked) {
                            let checkedInput = nodes.responseToggleWrap.querySelector(`input:checked:not(#${event.target.id}`);
                            if(checkedInput) checkedInput.checked = false;
                        }                          
                    })
                })

                nodes.editCancelButton.addEventListener("click", () => {
                    cancelEdit();
                })

                nodes.editSaveButton.addEventListener("click", () => {
                    editReportSave();
                })

                // initialize other widgets
                // logo_picker = $('#logo-selection-container').logoPicker();
                utilities.enableLogoPicker(nodes.modal)
                
                nodes.generateReportsButton.addEventListener("click", () => {
                    submitReports();
                })

                nodes.automateReportsButton.addEventListener("click", () => {
                    submitReports(true);
                })

                if(nodes.header) {
                    nodes.header.forEach(header => {
                        header.addEventListener("click", (e) => {
                            let content = e.target.nextElementSibling;
                            if(e.target.classList.contains("active")) {
                                e.target.classList.remove("active");
                                content.classList.add("hide");
                            } else {
                                e.target.classList.add("active");
                                content.classList.remove("hide");
                            }
                        })
                    })
                }

                if(nodes.npsMetricsToggle) {
                    nodes.npsMetricsToggle.addEventListener("change", event => {
                        if(event.target.checked) {
                            nodes.npsResponsesToggleWrap.classList.remove("disabled");
                        } else {
                            nodes.npsResponsesToggleWrap.classList.add("disabled");
                            nodes.npsResponsesToggle.checked = false;
                        }
                    })
                }                

                getSelectionsData("client", "client");

                createDataTable();
            }
        };
    }
);
